import {always} from 'ramda'

import {handleLocalActions} from 'app/utils/redux'

import * as actions from './factor-health-badge-actions'

const getInitialState = () => ({
  highlightedFactor: null,
  tooltip: {
    isVisible: false,
    left: null,
    right: null,
    top: null,
    factor: null,
  },
})

export default handleLocalActions({
  [actions.init]: getInitialState,
  [actions.deinit]: always(undefined),
  [actions.highlightFactor]: (state, action) => ({
    ...state,
    highlightedFactor: action.payload,
  }),
  [actions.clearHighlightedFactor]: (state, action) => ({
    ...state,
    highlightedFactor: getInitialState().highlightedFactor,
  }),
  [actions.showTooltip]: (state, action) => ({
    ...state,
    tooltip: {
      isVisible: true,
      left: action.payload.left,
      right: action.payload.right,
      top: action.payload.top,
      factor: action.payload.factor,
    },
  }),
  [actions.hideTooltip]: (state, action) => ({
    ...state,
    tooltip: getInitialState().tooltip,
  }),
})
